import { CircleAlert } from "lucide-react"
import * as React from "react"

import { cn } from "@/lib/utils"

/**
 * Info-tinted bar under the header. Only rendered when the Client Report
 * button is disabled.
 *
 * Spec is unambiguous: *"Do not show a disabled Client Report button
 * without the blocker named."* — a disabled button with no explanation
 * is worse than none. This strip is that explanation.
 */

export interface ReviewBlockerStripProps {
  message: string
  className?: string
}

export function ReviewBlockerStrip({
  message,
  className,
}: ReviewBlockerStripProps): JSX.Element {
  return (
    <div
      role="status"
      className={cn(
        "flex items-start gap-2 border-b border-info/20 bg-info-tint px-6 py-2 text-body-sm text-info-strong",
        className,
      )}
    >
      <CircleAlert className="mt-0.5 size-4 shrink-0 text-info" aria-hidden="true" />
      <p className="leading-normal">{message}</p>
    </div>
  )
}
